import React, { useState } from 'react';

import styles from './Text.module.scss';

interface CompProps {
  inline?: boolean;
  color?: string;
  size?: number;
  weight?: number;
  style?: string;
  expandable?: boolean;
  maxHeight?: string;
  underlined?: boolean;
  uberlined?: boolean;
  inlineStyle?: any;
}

const Text = (props: React.PropsWithChildren<CompProps>): React.ReactElement => {
  const { inline, expandable, underlined, uberlined, maxHeight = '80px', ...styleProps } = props;
  const [isExpanded, setExpanded] = useState<boolean>(false);
  const textStyle = {
    color: styleProps.color || 'inherit',
    size: styleProps.size || 'inherit',
    weight: styleProps.weight || 'inherit',
    style: styleProps.style || 'inherit',
  };

  const textClass =
    styles[`text-${textStyle.color}-${textStyle.size}-${textStyle.weight}-${textStyle.style}`];
  const inlineStyle = {
    ...(inline ? { display: 'inline' } : {}),
    ...(expandable && maxHeight ? { maxHeight } : {}),
    ...(props.inlineStyle || {}),
  };

  return (
    <>
      <div
        className={`${textClass} ${underlined ? styles.underlined : ''} ${
          uberlined ? styles.uberlined : ''
        } ${expandable ? styles.expandable : ''} ${
          expandable && isExpanded ? styles.expanded : ''
        }`}
        style={inlineStyle}
        onClick={expandable ? () => setExpanded((e) => !e) : undefined}
      >
        {props.children}
        {expandable && isExpanded && (
          <div className={styles.expander}>
            <i className="bi bi-chevron-up"></i>
          </div>
        )}
        {expandable && !isExpanded && (
          <div className={styles.expander}>
            ... <i className="bi bi-chevron-down"></i>
          </div>
        )}
      </div>
    </>
  );
};

export default Text;
